import React from 'react'

const CircledDropUp = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3333 10.0002C18.3333 5.39779 14.6024 1.66683 9.99999 1.66683C5.39762 1.66683 1.66666 5.39779 1.66666 10.0002C1.66666 14.6025 5.39762 18.3335 9.99999 18.3335C14.6024 18.3335 18.3333 14.6025 18.3333 10.0002Z" stroke="#2F3237" strokeWidth="1.5"/>
<path d="M6.66666 11.25C6.66666 11.25 9.12166 8.75 9.99999 8.75C10.8784 8.75 13.3333 11.25 13.3333 11.25" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}

export default CircledDropUp
